export default "__VITE_ASSET__B67ju6ux__"